import { Modal } from '@hive/component';
import { CollectionService } from '@hive/core/modules/collection';
import type { DialogComponentProps } from '@hive/core/modules/dialogs';
import type { WORKSPACE_DIALOG_SCHEMA } from '@hive/core/modules/dialogs/constant';
import type { Collection } from '@hive/env/filter';
import { useI18n } from '@hive/i18n';
import { useLiveData, useService } from '@toeverything/infra';
import { useCallback } from 'react';

import { EditCollection } from './edit-collection';

export const CollectionEditorDialog = ({
  close,
  collectionId,
  mode,
}: DialogComponentProps<WORKSPACE_DIALOG_SCHEMA['collection-editor']>) => {
  const t = useI18n();
  const collectionService = useService(CollectionService);
  const collection = useLiveData(collectionService.collection$(collectionId));
  const onConfirmOnCollection = useCallback(
    (collection: Collection) => {
      collectionService.updateCollection(collection.id, () => collection);
      close();
    },
    [close, collectionService]
  );
  const onCancel = useCallback(() => {
    close();
  }, [close]);

  if (!collection) {
    return null;
  }

  return (
    <Modal
      open
      onOpenChange={onCancel}
      withoutCloseButton
      width="calc(100% - 64px)"
      height="80%"
      contentOptions={{
        style: {
          padding: 0,
          maxWidth: 944,
          backgroundColor: 'var(--hive-background-primary-color)',
        },
      }}
      persistent
    >
      <EditCollection
        onConfirmText={t['com.hive.editCollection.save']()}
        init={collection}
        mode={mode}
        onCancel={onCancel}
        onConfirm={onConfirmOnCollection}
      />
    </Modal>
  );
};
